import React from 'react';
import { FileText, ExternalLink, CheckCircle2, Clock } from 'lucide-react';

const InvoiceCard = ({ invoice }) => {
  const isOpen = invoice.status === 'open';
  const amount = (invoice.amount_due || invoice.amount_paid) / 100;
  
  // Format date
  const date = new Date(invoice.created * 1000).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric'
  });

  return (
    <div className={`group flex flex-col sm:flex-row items-start sm:items-center justify-between p-5 rounded-xl border transition-all ${
      isOpen 
        ? 'bg-gradient-to-r from-red-500/10 to-orange-500/5 border-red-500/20 hover:border-red-400/40' 
        : 'bg-white/5 border-white/10 hover:bg-white/10'
    }`}>
      <div className="flex items-center gap-4 mb-4 sm:mb-0">
        <div className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 ${
          isOpen ? 'bg-red-500/20 text-red-400' : 'bg-emerald-500/20 text-emerald-400'
        }`}>
          {isOpen ? <Clock className="w-5 h-5" /> : <CheckCircle2 className="w-5 h-5" />}
        </div>
        <div>
          <div className="text-white font-medium flex items-center gap-2 text-lg">
            Invoice {invoice.number || invoice.id.substring(0, 8)}
            <span className={`text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wider font-bold ${
              isOpen ? 'bg-red-500/20 text-red-300' : 'bg-emerald-500/20 text-emerald-300'
            }`}>
              {invoice.status}
            </span>
          </div>
          <div className="text-white/50 text-sm mt-0.5">{date}</div>
        </div>
      </div>

      <div className="flex items-center w-full sm:w-auto justify-between sm:justify-end gap-6">
        <div className="text-2xl font-mono text-white font-semibold">
          ${amount.toFixed(2)}
        </div>
        
        {isOpen ? (
          <a 
            href={invoice.hosted_invoice_url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-sm font-semibold rounded-lg hover:from-blue-500 hover:to-indigo-500 transition-all shadow-[0_0_20px_rgba(59,130,246,0.3)] hover:shadow-[0_0_25px_rgba(59,130,246,0.5)] transform hover:-translate-y-0.5"
          >
            Pay Now <ExternalLink className="w-4 h-4" />
          </a>
        ) : (
          <a 
            href={invoice.invoice_pdf || invoice.hosted_invoice_url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 text-white/80 text-sm font-medium rounded-lg hover:bg-white/10 hover:text-white transition-all"
          >
            <FileText className="w-4 h-4" /> Receipt
          </a>
        )}
      </div>
    </div>
  );
};

export default InvoiceCard;
